import { html } from '@design.estate/dees-element';
import { demoPage, demoSection } from '../../../demos/templates.js';

export const demoFunc = () => demoPage('Reference composer', 'Type #_ to search at the cursor. Choose a ticket and continue writing.',
  demoSection('Ticket references', 'References preserve IDs through editing, undo and copy/paste.', html`
    <dees-input-reference .searchReferences=${async (query: string) => [
      { id: 'ticket-1', label: '#CAT-101 Keyboard navigation' }, { id: 'ticket-2', label: '#CAT-102 Ticket detail' },
    ].filter(item => item.label.toLowerCase().includes(query.toLowerCase()))}></dees-input-reference>
  `));
